import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import Select from 'react-select'
import { API_URL } from '..';
const AddStaffLayer = () => {

    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
   const [selectedValue , setSelectedValue] = useState({})
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleChangeRole = (selected) =>{
        setSelectedValue(selected || {})
    }
    const onFormSubmission = async (event) =>{
        event.preventDefault();
        if(event.target.elements.password.value !==  event.target.elements.confirmPassword.value){
            alert('Password are not matched');
            return false;
        }
            try {
                    let headerList = {
                        'Accept' : '*/*',
                        'Content-type' : 'application/json'
                    }
                    let bodyContent = JSON.stringify({
                        "name":event.target.elements.name.value,
                        "email":event.target.elements.email.value,
                        "password":event.target.elements.password.value,
                        "role":selectedValue?.value,
                        "phone":event.target.elements.phone.value,
                    })
                    const response = await fetch(API_URL+'/api/user/create', {
                        method:'POST',
                        body:bodyContent,
                        headers:headerList
                    })
                    const data = await response.json();
                    if(response.status === 201){
                       console.log(data)
                    }else{
                        alert('Invalid Credentials');
                    }
            } catch (error) {
                console.log(error.message)
            }
    }
    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                
                                {/* Upload Image End */}
                                <form onSubmit={onFormSubmission}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Full Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            name='name'
                                            placeholder="Enter Full Name"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="email"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Email <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control radius-8"
                                            id="email"
                                            name='email'
                                            placeholder="Enter email address"
                                        />
                                    </div>
                                    
                                    <div className="mb-20">
                                        <label
                                            htmlFor="number"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Phone
                                        </label>
                                        <input
                                            type="tel"
                                            className="form-control radius-8"
                                            id="number"
                                            name='phone'
                                            placeholder="Enter phone number"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="number"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Select Role
                                        </label>
                                        <Select 
                                        options={[
                                            {
                                                label:'Admin',
                                                value:'admin',

                                            },
                                            {
                                                label:'User',
                                                value:'user'
                                            },
                                           
                                            {
                                                label:'Electrician',
                                                value:'electrician',

                                            }
                                        ]}
                                        placeholder="Select Role"
                                        value={selectedValue}
                                        onChange={handleChangeRole}
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="password"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control radius-8"
                                            id="password"
                                            name='password'
                                            placeholder="*******"
                                        />
                                    </div>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="confirmPassword"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Confirm Password
                                        </label>
                                        <input
                                            type="password"
                                            className="form-control radius-8"
                                            id="confirmPassword"
                                            name='confirmPassword'
                                            placeholder="*******"
                                        />
                                    </div>
                                  
                                  
                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                      
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-400 text-md px-56 py-12 radius-8"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default AddStaffLayer;